import { render, staticRenderFns } from "./DetailTNACompetency.vue?vue&type=template&id=be55783c&scoped=true"
import script from "./DetailTNACompetency.vue?vue&type=script&lang=js"
export * from "./DetailTNACompetency.vue?vue&type=script&lang=js"
import style0 from "./DetailTNACompetency.vue?vue&type=style&index=0&id=be55783c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be55783c",
  null
  
)

export default component.exports